<template>
    <div>
        <div class="topcode-wechat-taskDetail-item" @click="startDeal">
            <span :class="'sign sign-'+taskDetail.state">{{$DICT.getValue('SAFETY_TASK_POSITION_STATE', taskDetail.state)}}</span>
            <!--<div class="top">-->
            <!--<div :class="'flex-center-y state  time'">{{taskDetail.handleTime}}</div>-->
            <!--</div>-->

            <div class="body">
                <div class="content">
                    <div class="flex-center-y center">
                        <img :src="downloadImg + taskDetail.image"/>
                        <div class="name" style="font-size: 14px">
                            <div class="title">{{taskDetail.name}}</div>
                            <div style="color: #7e7e7e">{{taskDetail.remark}}</div>
                        </div>
                    </div>
                </div>
                <div class="flex-center right" v-if="taskDetail.state=='UN_HANDLE'&&canHandle">
                    <span v-if="canHandle">处理</span>
                    <span v-else>查看</span>
                    <van-icon name="arrow"/>
                </div>
                <div class="flex-center right" v-else-if="taskDetail.state=='HANDLE'">
                    <span >查看</span>
                    <van-icon name="arrow"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {downloadImg} from "@/config"
    import UploadImage from "@/components/UploadImage";
    import {Cell, CellGroup,} from "vant"


    export default {
        components: {
            UploadImage, Cell, CellGroup,
        },
        props: {
            taskDetail: {type: Object, required: true}
        },
        data() {
            return {
                downloadImg,
            };
        },
        computed: {
            ...mapGetters({permissions: 'global/permissions'}),
            canHandle() {
                return this.permissions.includes('SAFETY_TASK_HANDLE') && this.$route.params.state == 'UN_FINISH'
            },
        },
        created() {
        },
        mounted() {
        },
        methods: {
            startDeal() {
                // this.canHandle && this.$emit('onDeal', this.taskDetail)
                this.$emit('onDeal', this.taskDetail)
            },
        },
        watch: {}
    };
</script>

<style lang="less" scoped>
    .topcode-wechat-taskDetail-item {
        width: 100%;
        /*height: 225px;*/
        padding-bottom: 3px;
        margin-bottom: 8px;
        border-radius: 8px;
        border: 1px #cccccc solid;
        /*background: #51c332;*/
        position: relative;
        overflow: hidden;

        & > .top {
            color: #fff;
            display: flex;
            height: 23px;
            border-radius: 8px 8px 0px 0px;
            background: #7e7e7e;
            & > .time {
                height: 100%;
                width: 100%;
                padding-left: 15px;
                justify-content: flex-start;

            }
        }
        & > .body {
            display: flex;
            & > .right {
                color: #fa7d2d;
                font-size: 14px;
                font-weight: 500;
            }
            & > .content {
                /*padding: 8px;*/
                width: calc(100% - 70px);
                & > .center {
                    padding: 5px;
                    display: flex;
                    /*background: #5cd8bc;*/
                    & > img {
                        width: 65px;
                        height: 65px;
                        background: #cccccc;
                        // border-radius: 8px;
                    }
                    & > .name {
                        padding-left: 20px;
                        height: 100%;
                        display: flex;
                        /*background: #7e7e7e;*/
                        flex-direction: column;

                        & > div {
                            line-height: 1.5;

                        }
                    }
                }
                & > .row {
                    display: flex;
                    line-height: 1.5;
                    /*align-items: center;*/
                    & > label {
                        width: 105px;
                        flex-shrink: 0;
                        &::after {
                            margin-left: 2px;
                            content: '：';
                        }
                    }
                    & > span {
                    }
                }
            }
        }
    }

    .sign {
        &.sign-UN_HANDLE {
            background: #1890ff;
        }
        &.sign-HANDLE {
            background: #52c41a;
        }
        font-family: 微软雅黑;
        text-decoration: none;
        display: block;
        position: absolute;
        right: 0px;
        width: 150px;
        height: 25px;
        font-size: 10px;
        /*background-color: red;*/
        color: #fff;
        font-weight: bold;
        line-height: 28px;
        text-align: center;
        transform: translate(55px, 4px) rotate(40deg);
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5), inset 0 0 2px #fff;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
    }
</style>
